// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1sPhh","col":"styles_col__3JpxY","fulfillmentStatus":"styles_fulfillmentStatus__25S9m","emailCol":"styles_emailCol__3mvuS"};